/* eslint semi:0 */
import React from 'react'
import { allTrue } from '../../jsCore/utils/fn'
import { connect } from 'react-redux'
import { domainFromFqdn } from '../../jsCore/utils/ua'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { t } from '../../jsCore/providers/i18nProvider/i18nProvider'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import { DisclaimerHeader } from './components/disclaimerHeader'
import { DisclaimerMessage } from './components/disclaimerMessage'
import { DisclaimerWrapper } from './components/disclaimerWrapper'
import { communityDisclaimerReducer } from './communityDisclaimerReducer'
import { communityDisclaimerActions } from './communityDisclaimerActions'
import { get as getFromPdo, isSupportedForDomain } from '../../jsCore/application/pageDataObject'

const COMPONENT_NAME = 'communityDisclaimerContainer'
const STATE_KEY = 'communityDisclaimer'
const COMMUNITY_DISCLAIMER_EPOCH = 1422788400
const EXCLUDED_CASTR_STATUSES = ['published']
const PDO_PATH = 'post'
const REQUIRED_DATA_FROM_PDO = ['created_at', 'castr_status', 'author']
const COMMUNITY_DISCLAIMER_FEATURE_ID = 'CommunityDisclaimer'

function getPageData(path, pdoFields) {
  const dataObject = getFromPdo(path, {})
  return pdoFields.reduce(
    (dataFromPdo, field) => ({ ...dataFromPdo, [field]: dataObject[field] }),
    {}
  )
}

function shouldMountComponent() {
  if (!isSupportedForDomain(COMMUNITY_DISCLAIMER_FEATURE_ID)) {
    return false
  }
  const { created_at: createdAt, castr_status: castrStatus, author } = getPageData(
    PDO_PATH,
    REQUIRED_DATA_FROM_PDO
  )
  return allTrue(
    createdAt > COMMUNITY_DISCLAIMER_EPOCH,
    !EXCLUDED_CASTR_STATUSES.includes(castrStatus),
    author
  )
}

class CommunityDisclaimer extends React.Component {
  componentWillMount() {
    this.props.fetchData()
  }

  get disclaimer() {
    return (
      <DisclaimerWrapper>
        <DisclaimerHeader>
          {t('post_page.community_content')}
        </DisclaimerHeader>
        <DisclaimerMessage>
          {this.props.communityDisclaimerI18nKeysByDomain[domainFromFqdn()]}
        </DisclaimerMessage>
      </DisclaimerWrapper>
    )
  }

  render() {
    return this.props.isFeatured ? this.disclaimer : false
  }
}

function mapStateToProps(state) {
  const { isFeatured, communityDisclaimerI18nKeysByDomain } = state[STATE_KEY]
  return {
    isFeatured,
    communityDisclaimerI18nKeysByDomain,
  }
}

export const communityDisclaimerContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStateToProps, communityDisclaimerActions)(CommunityDisclaimer),
  reducer: communityDisclaimerReducer,
}

function mountCommunityDisclaimer() {
  return reduxMount({
    [MOUNT_POINTS.COMMUNITY_DISCLAIMER]: communityDisclaimerContainer,
  })
}

export default function initCommunityDisclaimer() {
  const shouldMountCommunityDisclaimer = shouldMountComponent()
  if (shouldMountCommunityDisclaimer) {
    mountCommunityDisclaimer()
  }
  return shouldMountCommunityDisclaimer
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/community_disclaimer/communityDisclaimerContainer.js